<script setup>
defineProps({
  indeterminate: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['change']);

// UI-FILTROS-01 (G12): o que descreve o controle vai para o <input>, que é quem o leitor de tela
// anuncia: id, name, value e aria-* (o aria-label do Kanban caía na <div>, e a caixa ficava sem
// nome). O resto fica na <div> como antes: class, style e os on*, porque o AddSourceDialog põe
// class e @click.stop nela.
defineOptions({ inheritAttrs: false });

const modelValue = defineModel('modelValue', {
  type: Boolean,
  default: false,
});

const DO_INPUT = ['id', 'name', 'value'];
// Os data-* também: quem procura a caixa por um data-* quer o <input>, que é o que se marca.
const vaiAoInput = chave =>
  DO_INPUT.includes(chave) ||
  chave.startsWith('aria-') ||
  chave.startsWith('data-');
const separar = (attrs, doInput) =>
  Object.fromEntries(
    Object.entries(attrs).filter(([chave]) => vaiAoInput(chave) === doInput)
  );

const handleChange = event => {
  modelValue.value = event.target.checked;
  emit('change', event);
};
</script>

<template>
  <div class="relative w-4 h-4 shrink-0" v-bind="separar($attrs, false)">
    <input
      v-bind="separar($attrs, true)"
      :checked="modelValue"
      :indeterminate="indeterminate"
      type="checkbox"
      :disabled="disabled"
      class="peer absolute inset-0 z-10 h-4 w-4 disabled:opacity-50 appearance-none rounded border border-n-control ring-transparent focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-n-brand transition-all duration-200 checked:border-n-brand checked:bg-n-brand dark:checked:border-n-brand indeterminate:border-n-brand indeterminate:bg-n-brand hover:enabled:bg-n-blue-border cursor-pointer"
      @change="handleChange"
    />
    <!-- Checkmark SVG -->
    <svg
      viewBox="0 0 14 14"
      fill="none"
      class="pointer-events-none absolute w-3.5 h-3.5 z-20 stroke-white opacity-0 peer-checked:opacity-100 transition-opacity duration-200 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <path
        d="M3 8L6 11L11 3.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <!-- Minus/Indeterminate SVG -->
    <svg
      viewBox="0 0 14 14"
      fill="none"
      class="pointer-events-none absolute w-3.5 h-3.5 z-20 stroke-white opacity-0 peer-indeterminate:opacity-100 transition-opacity duration-200 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    >
      <path
        d="M3 7L11 7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
